// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
// mainapp bundle app settings
module.exports = angular.module('bench.config.app', []).constant('appConfig', {
  name: 'mainapp',
  feed: {
    eventTypes: [
      'feed.message.created',
      'feed.message.edited',
      'feed.receipt.created',
      'event.categorization.requested',
    ],
  },

  menuItems: [
    {
      title: 'Tools',
      items: [
        {
          name: 'New Dashboard',
          state: 'bench.messaging',
        },
        {
          name: 'Client Details',
          state: 'bench.details.overview',
        },
        {
          name: 'Categorizer Rules',
          state: 'bench.categorizer',
        },
        {
          name: 'Folders',
          state: 'bench.dms.statements.all',
        },
      ],
    },
  ],
});
